import {Utils} from '../../utils/utils';

const _map = {
    id: 'name',
    src: 'url'
};

export const ManifestCreateJSToPIXI = source => {
    if (source instanceof Array) return Utils.renameProperties(source, _map);

    if (!source.manifest || !(source.manifest instanceof Array)) return source;

    const obj = Utils.extend({}, source);
    obj.manifest = Utils.renameProperties(source.manifest, _map);
    return obj;
};
